package navigation.settings.currency

import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module
import navigation.settings.currency.addcurrency.AddCurrencyScreenModel
import navigation.settings.currency.allowedcurrencies.AllowedCurrenciesScreenModel


val currencyUiModule
    get() =
        module {
            factoryOf(::AddCurrencyScreenModel)
            factoryOf(::AllowedCurrenciesScreenModel)
        }